import React from 'react';
import { Box, Card, CardContent, Typography, Button, Alert } from '@mui/material';
import { Warning, Refresh } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled React Render Error:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f0f4f8', p: 3 }}>
          <Card sx={{ maxWidth: 500, width: '100%', borderRadius: 3, boxShadow: '0 8px 30px rgba(0,0,0,0.1)' }}>
            <CardContent sx={{ p: 4, textAlign: 'center' }}>
              <Warning sx={{ fontSize: 60, color: '#d32f2f', mb: 2 }} />
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Something went wrong
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                An unexpected error occurred while rendering the page.
              </Typography>

              {this.state.error?.message && (
                <Alert severity="error" sx={{ mb: 3, textAlign: 'left', fontSize: '0.85rem' }}>
                  {this.state.error.message}
                </Alert>
              )}

              <Button
                variant="contained"
                color="primary"
                startIcon={<Refresh />}
                onClick={this.handleReload}
                sx={{ fontWeight: 700, px: 3, py: 1 }}
              >
                Reload Page
              </Button>
            </CardContent>
          </Card>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
